import { Routes, Route, useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
// import Team from './pages/Team' // Merged into About page
import Projects from './pages/Projects' // Now includes Events/Competitions
// import Sponsors from './pages/Sponsors' // Deactivated - uncomment to reactivate
// import Events from './pages/Events' // Merged into Projects page
import Contact from './pages/Contact'

function App() {
  const location = useLocation()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ 
              duration: 0.3,
              ease: "easeInOut"
            }}
            style={{ width: '100%', height: '100%' }}
          >
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              {/* <Route path="/team" element={<Team />} /> */} {/* Merged into About */}
              <Route path="/projects" element={<Projects />} /> {/* Includes Competitions */}
              {/* <Route path="/sponsors" element={<Sponsors />} /> */} {/* Deactivated */}
              {/* <Route path="/events" element={<Events />} /> */} {/* Merged into Projects */}
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
      </Box>
      <Footer />
    </Box>
  )
}

export default App
